import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/react-fontawesome";
import { InlineImage } from "../../components/InlineImage";
import { faCar } from "@fortawesome/free-solid-svg-icons";

export default function Day06() {
  return (
    <div className="box light">
      <div className="row">
        <h1>Dag 23 - 2 augustus</h1>
        <h2>
          Amsterdam <FontAwesomeIcon icon={faCar} /> Nijmegen
        </h2>

        <InlineImage width="30%" image="costarica/dag23-01.jpg" webp float="right" />
        <p>
          Om 13.00 uur landen we veilig op Schiphol. Bijna thuis! Tenminste, dat denken we. We moeten alleen nog even door de douane. Daar staat een flinke rij en omdat we nog even
          op elkaar hebben gewacht, sluiten we helemaal achteraan aan. Maar er zit totaal geen schot in de rij. Mensen voor ons beginnen inmiddels te mopperen tegen het personeel.
          Gezinnen met kinderen jonger dan 14 jaar moeten blijkbaar in deze rij staan, terwijl de rest ogenschijnlijk gewoon door mag lopen. Wij staan dus braaf te wachten en
          kijken toe hoe de rij maar nauwelijks korter wordt.
        </p>
        <p>
          Het gemopper lijkt uiteindelijk te werken, want even later worden we eindelijk 'losgelaten' en mogen we door naar de hal waar de échte rij staat. Daar blijkt het echter
          ook nog behoorlijk druk. Uiteindelijk duurt het, vanaf het moment dat we in de rij aansluiten, zo'n twee uur voordat we eindelijk Schiphol uit lopen.
        </p>
        <p>
          Met de bus rijden we vervolgens naar parkeerplaats P5, waar onze eigen auto al drie weken op ons staat te wachten. Terwijl de rest bij de koffers blijft, haalt Ivo de
          auto op. Maar dan zijn er toch nog grote problemen: de auto wil niet starten! Het oude beestje heeft wel vaker last gehad van de accu en drie weken stilstaan blijkt
          kennelijk funest. Gelukkig hebben we destijds een jumpstarter aangeschaft. Die komt nu uitstekend van pas, want daarmee start de auto direct. Eindelijk kunnen we dan écht
          op pad, richting Nijmegen. Anderhalf uur later zijn we helemaal thuis en ploffen we op de bank. Oost west, thuis best.
        </p>
      </div>
    </div>
  );
}
